import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StartComponent } from './start/start.component';
import { EndComponent } from './end/end.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { authGuard } from './guards/auth.guard';
import { VerifyComponent } from './verify/verify.component';

const routes: Routes = [
  { path: "verify", component: VerifyComponent },
  { path: "complete", component: EndComponent },

  { path: ":token/:publicKey", component: StartComponent, canActivate: [authGuard] },
  { path: ":token", component: StartComponent, canActivate: [authGuard] },

  { path: "", component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
